const FNV_OFFSET = 0x811c9dc5;
const FNV_PRIME = 0x01000193;

export function fnv1a(input) {
  const str = String(input ?? '');
  let hash = FNV_OFFSET;
  for (let i = 0; i < str.length; i++) {
    hash ^= str.charCodeAt(i);
    hash = Math.imul(hash, FNV_PRIME);
  }
  return (hash >>> 0).toString(36);
}

export function cartItemId(productId, graphicFront, graphicBack, designId) {
  // Für Design-Items ist die designId die Identität (das Produkt ist
  // impliziert). Sonst Hash über die Grafik-Werte (Legacy: URL oder
  // Farbe/QR-JSON).
  const key = designId ? `d:${designId}` : `${graphicFront ?? ''}|${graphicBack ?? ''}`;
  return `${productId}_${fnv1a(key)}`;
}
